<template>
  <el-dialog :title="title"
    width="600px"
    :close-on-click-modal="false"
    :visible="true"
    @close="handleClose" >
    <div class="child_form_filter_dialog">
      <VirtualScrollList v-if="filters && filters[0]"
        ref="scrollList"
        :size="44"
        :remain="5" >
        <div class="child_form_filter_item"
          v-for="(i,index) in filters"
          :key="i._key">
          <el-select v-model="i.sourceField"
            class="flex-fill"
            :popper-append-to-body="false"
            @change="handleResetBindValue(i)"
            size="small">
            <el-option  v-for="t in sourceFieldList"
              :key="t.columnKey"
              :label="t.columnName"
              :value="t.columnKey"/>
          </el-select>
          <span class="ml-1 mr-1" style="width:120px;text-align:center">的值填充到</span>
          <el-select
            class="flex-fill"
            :popper-append-to-body="false"
            v-model="i.targetField"
            size="small">
             <el-option v-for="t in filterdBindFieldList(i.sourceField)"
              :key="t.__config__.renderKey"
              :label="t.__config__.label"
              :value="t.__config__.renderKey">
            </el-option>
          </el-select>
          <i class="el-icon-remove-outline ml-1" @click="handleRemove(index)"></i>
        </div>
      </VirtualScrollList>
      <el-empty v-else description="暂无数据" :image-size="80" class="mb-2"></el-empty>
      <div class="child_form_filter_new" @click="handleNew">
        <i class="el-icon-plus"></i>
      </div>
    </div>
    <span slot="footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleConfirm">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import _ from 'lodash';
import VirtualScrollList from 'vue-virtual-scroll-list';
import getComponentMatcher from '../../utils/componentMatcher';
export default {
  name: 'childFormConfigFieldFillDialog',
  components: {
    VirtualScrollList,
  },
  props: {
    title: {
      type: String,
      default: '数据填充规则',
    },
    value: Array,
    sourceFieldList: {
      type: Array,
      default: ()=>[],
    },
    bindFiledList: {
      type: Array,
      default: ()=>[],
    },
  },
  data () {
    return {
      filters: _.cloneDeep(this.value) || [],
    };
  },
  methods: {
    filterdBindFieldList (sourceField) {
      let column = this.sourceFieldList.find(t=>t.columnKey === sourceField);
      const tag = column?.columnValue?.__config__?.tag;
      if (!column || !tag) {
        return [];
      } else {
        const componentMatcher = getComponentMatcher(column?.columnValue);
        return this.bindFiledList.filter(componentMatcher);
      }
    },
    handleResetBindValue (i) {
      i.targetField = null;
    },
    handleRemove (index) {
      this.filters.splice(index, 1);
    },
    handleNew () {
      this.filters.push({
        _key: `${new Date().getTime()}_${this.filters.length}`,
        sourceField: null,
        targetField: null,
      });
      this.$nextTick(()=>{
        this.$refs.scrollList.forceRender();
      });
    },
    handleClose () {
      this.$emit('close');
    },
    handleConfirm () {
      if (this.filters.some(t=>!t.sourceField || !t.targetField)) {
        this.$message.error('请补全数据填充规则');
        return;
      }
      this.$emit('input', this.filters);
      this.handleClose();
    },
  },
};
</script>

<style lang="scss" scoped>
  .child_form_filter_dialog {
    overflow: hidden;
    &>div {
      max-height: 240px;
      overflow: auto;
      padding: 0 32px;
      .child_form_filter_item {
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-bottom: 12px;

        &>*:nth-child(1) {
          width: 240px!important;
        }
        &>*:nth-child(3){
          width: 300px!important;
        }

        .el-icon-remove-outline {
          font-size: 16px;
          cursor: pointer;
          color: $danger-color;
        }
      }
    }

    .child_form_filter_new {
      border: 1px dashed $primary-color;
      border-radius: 4px;
      width: 70%;
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 8px 0;
      color: $primary-color;
      cursor: pointer;
    }
  }
</style>
